<template>
    <w-card class="table-bar-search-bottom bd0 text-right custom-pagination">
        <w-flex class="justify-start align-center">
            <w-select
                label-position="left"
                class="xs1"
                :items="perPageOption"
                v-model="pagination.perPage"
                @item-select="onPerPageChange"
            >
            </w-select>
            <div class="xs11 justify-end" v-if="pagination.lastPage == 1">
                <w-button
                    @click="goto(1)"
                    :bg-color="pagination.currentPage === 1 ? 'primary' : ''"
                    :class="
                        pagination.currentPage === 1 ? 'disabled ma1' : 'ma1'
                    "
                    text
                    >1</w-button
                >
            </div>

            <div class="xs11 justify-end" v-if="pagination.lastPage > 1">
                <w-button
                    :class="pagination.currentPage === 1 ? 'disabled' : ''"
                    text
                    @click="previousPage"
                    >&laquo;</w-button
                >
                <w-button
                    @click="goto(1)"
                    :bg-color="pagination.currentPage === 1 ? 'primary' : ''"
                    :class="
                        pagination.currentPage === 1 ? 'disabled ma1' : 'ma1'
                    "
                    text
                    >1</w-button
                >

                <span
                    class="ma1 dotdotdot"
                    color="primary"
                    v-show="pagination.currentPage > 3"
                    >&hellip;</span
                >

                <w-button
                    v-for="n in pagination.lastPage - 2"
                    v-show="
                        (n + 1 >= pagination.currentPage - 2 &&
                            n + 1 <= pagination.currentPage + 2) ||
                        (pagination.currentPage <= 2 && n < 5) ||
                        (pagination.currentPage >= pagination.lastPage - 2 &&
                            n + 1 > pagination.lastPage - 5)
                    "
                    @click="goto(n + 1)"
                    :bg-color="
                        pagination.currentPage === n + 1 ? 'primary' : ''
                    "
                    class="ma1"
                    text
                    >{{ n + 1 }}</w-button
                >

                <span
                    class="ma1 dotdotdot"
                    color="primary"
                    v-show="pagination.currentPage <= pagination.lastPage - 3"
                    >&hellip;</span
                >

                <w-button
                    @click="goto(pagination.lastPage)"
                    :bg-color="
                        pagination.currentPage === pagination.lastPage
                            ? 'primary'
                            : ''
                    "
                    :class="
                        pagination.currentPage === pagination.lastPage
                            ? 'disabled ma1'
                            : 'ma1'
                    "
                    text
                    >{{ pagination.lastPage }}</w-button
                >

                <w-button
                    class="ma1"
                    text
                    @click="nextPage"
                    :class="
                        pagination.currentPage === pagination.lastPage
                            ? 'disabled'
                            : ''
                    "
                    >&raquo;</w-button
                >
            </div>
        </w-flex>
    </w-card>
</template>

<script>
import { ref, defineComponent, onMounted, watch } from "vue";
export default defineComponent({
    props: {
        currentPage: {
            type: Number,
            default: 1,
        },
        perPage: {
            type: Number,
            default: 10,
        },
        lastPage: {
            type: Number,
            default: 1,
        },
        perPageOption: {
            type: Array,
            default: [
                { label: "5", value: 5 },
                { label: "10", value: 10 },
                { label: "50", value: 50 },
                { label: "100", value: 100 },
            ],
        },
    },
    emits: ["onClick"],
    setup(props, { emit }) {
        const pagination = ref({
            currentPage: props.currentPage,
            lastPage: props.lastPage,
            perPage: props.perPage,
        });

        watch(props, (nv, ov) => {
            pagination.value = {
                currentPage: nv.currentPage,
                lastPage: nv.lastPage,
                perPage: nv.perPage,
            };
        });

        function goto(p) {
            pagination.value.currentPage = p;
            onPageChange();
        }

        function previousPage() {
            const cp = pagination.value.currentPage;
            pagination.value.currentPage = cp != 1 ? cp - 1 : cp;
            onPageChange();
        }

        function nextPage() {
            const cp = pagination.value.currentPage;
            const lp = pagination.value.lastPage;
            pagination.value.currentPage = cp != lp ? cp + 1 : cp;
            onPageChange();
        }

        function onPageChange() {
            emit("onClick", pagination);
        }

        function onPerPageChange() {
            pagination.value.currentPage = 1;
            emit("onClick", pagination);
        }

        return {
            pagination,
            goto,
            previousPage,
            nextPage,
            onPerPageChange,
        };
    },
});
</script>
<style>
.custom-pagination.table-bar-search-bottom {
    border: none !important;
    background-color: #fff !important;
}
.custom-pagination > div > div > div.xs11.justify-end > span.ma1.dotdotdot {
    color: var(--primary) !important;
}
</style>
